import {gql} from 'graphql-request';

import {
  type NotifyChange,
  type SubscriptionMessageSubscriptionArgs,
} from '@prompt-bridge/shared/appsync';

export type MessageSubscriptionResponse = {
  messageSubscription: NotifyChange;
};

type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

/**
 * GraphQL subscription string for messageSubscription
 * Subscribes to message changes based on tenantId, userId and optional branchId
 */
export const MESSAGE_SUBSCRIPTION = gql`
  subscription MessageSubscription($tenantId: String!, $userId: String!, $branchId: String) {
    messageSubscription(tenantId: $tenantId, userId: $userId, branchId: $branchId) {
      id
      branchId
      tenantId
      userId
      useCaseType
      messageId
      status
      createdAt
      payload
    }
  }
` as GeneratedSubscription<MessageSubscriptionVariables, MessageSubscriptionResponse>;

export type MessageSubscriptionVariables = SubscriptionMessageSubscriptionArgs;
